import { render, staticRenderFns } from "./buyerDoc.vue?vue&type=template&id=50f88f2e&scoped=true&"
import script from "./buyerDoc.vue?vue&type=script&lang=js&"
export * from "./buyerDoc.vue?vue&type=script&lang=js&"
import style0 from "./buyerDoc.vue?vue&type=style&index=0&id=50f88f2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f88f2e",
  null
  
)

export default component.exports